export default __webpack_public_path__ + "static/Residencia-universitaria-Sarriá-6139b06ec8a5787c335a8605367f666f.svg";